import { createContext, useContext, useState, useEffect, type ReactNode } from 'react'
import { api } from '@/lib/api'

interface ApiContextValue {
  connected: boolean
  checking: boolean
}

const ApiContext = createContext<ApiContextValue>({ connected: false, checking: true })

export function ApiProvider({ children }: { children: ReactNode }) {
  const [connected, setConnected] = useState(false)
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    api.healthCheck().then((ok) => {
      setConnected(ok)
      setChecking(false)
    })
  }, [])

  return (
    <ApiContext.Provider value={{ connected, checking }}>
      {children}
    </ApiContext.Provider>
  )
}

export function useApiStatus() {
  return useContext(ApiContext)
}
